import { ControlType, FieldBaseOptions } from './field-base';
import { DropdownField, Option } from './field-dropdown';

// TODO: partner center and sales and success center have a different user object
// this should be normalized at some point in time....
export interface User {
  userId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  phoneNumbers?: string[];
}

export interface VBCUserFieldOptions extends FieldBaseOptions {
  users: User[];
}

export class VBCUserField extends DropdownField {
  readonly controlType: ControlType = 'vbcuser';

  constructor(options: VBCUserFieldOptions) {
    super({
      id: options.id,
      label: options.label,
      required: options.required,
      description: options.description,
      options: getOptions(options.users),
      disabled: options.disabled,
      forOfficeUseOnly: options.forOfficeUseOnly,
      officeEditableOnly: options.officeEditableOnly,
    });
  }
}

function getOptions(vbcUsers: User[]): Option[] {
  if (vbcUsers && vbcUsers.length > 0) {
    vbcUsers.sort(compareUsersByEmail);
    return vbcUsers.map((user) => {
      const labelString = createLabelString(user.firstName, user.lastName, user.email);

      if (user.userId && user.email && user.firstName && user.lastName) {
        let phoneNumberValue = '';

        if (user.phoneNumbers && user.phoneNumbers.length > 0) {
          phoneNumberValue = user.phoneNumbers[0];
        } else if (user.phoneNumber) {
          phoneNumberValue = user.phoneNumber;
        }

        return {
          label: labelString,
          value: JSON.stringify({
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            phoneNumber: phoneNumberValue,
            id: user.userId,
          }),
        };
      }
      return {
        label: labelString + ' - First and last name required',
        value: '',
        disabled: true,
      };
    });
  }
  return [{ label: 'FRONTEND.STORE.ORDER_FORM.NO_USERS_INSTRUCTIONS', value: '', disabled: true }];
}

function compareUsersByEmail(a: User, b: User): number {
  if (a == null) {
    return -1;
  }
  if (b == null) {
    return 1;
  }
  return a.email.localeCompare(b.email);
}

function createLabelString(firstName: string, lastName: string, email: string): string {
  let returnString = '';
  returnString += firstName ? firstName + ' ' : '';
  returnString += lastName ? lastName + ' ' : '';
  returnString += email ? `(${email})` : '';
  return returnString;
}
